/* eslint-disable quotes */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-tabs */
const imageList = [
  {
    title: 'TAL_OCR_MATH小学低年级算式数据集',
    download: 'TAL_OCR_MATH',
    description:
      '算数数据集为小学数学1到3年级的学生手写数学式子，共3万图片。每个数学式子经过手工裁剪。每个图像提供了对应标注。特殊数学符号标注方式请查看字符对应表。（文件87.04MB）',
    list: [
      {
        label: '数据规模',
        text: '3万张图片'
      },
      {
        label: '数据类型',
        text: '小学1~3年级学生习题册'
      },
      {
        label: '公式类型',
        text: '横式'
      },
      {
        label: '运算',
        text: '加、减、乘、除'
      },
      {
        label: '数据格式',
        text: '图片：.jpg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_MATH.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123384&Signature=tJnKYwJBNL0vxJT3KpzUBH8M8Ug%3D',
    fileStyle: {
      width: '243px',
      height: '80px'
    },
    result: '340b14=Z4Z7Z6Z0（b：代表×，Z：手写标志）'
  },
  {
    title: 'TAL_OCR_CHN手写中文数据集',
    download: 'TAL_OCR_CHN',
    description:
      '手写中文数据集为30名大学生手写的中文古诗词，总计11743张图片，每张图片提供了对应的文本内容标注。（文件183.92MB）',
    list: [
      {
        label: '数据规模',
        text: '11739张图片'
      },
      {
        label: '数据类型',
        text: '手写中文古诗词'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_CHN.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123413&Signature=q2pSnzNG0xdTpBw5z5GBrDi8tY4%3D',
    fileStyle: {
      width: '592px',
      height: '58px'
    },
    result: '加。柳下桃蹊，乱分春色到人家。'
  },
  {
    title: 'TAL_OCR_ENG手写英文数据集',
    download: 'TAL_OCR_ENG',
    description:
      '手写英文数据集为学生手写英文作文，总计1万行英文，对应1万张图片，每张图片提供了对应的文本内容标注。（文件222.16MB）',
    list: [
      {
        label: '数据规模',
        text: '1万张图片'
      },
      {
        label: '数据类型',
        text: '手写英文'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_ENG.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123438&Signature=HlCFi8izUji0pLvZPdwhtWzcwDI%3D',
    fileStyle: {
      width: '644px',
      height: '55px'
    },
    result: 'Because eating fast food is a simple way to eat.'
  },
  {
    title: 'HME100K',
    download: 'TAL_OCR_FORMULA',
    description:
      'The HME100K dataset provides 99,109 images (74,502 for training and 24,607 for testing) with 245 kinds of symbol classes. The data size is increased tenfold compared to the CRHOME datasets. HME100K acquires the expressions from an Internet application. Therefore, we may assume that the expressions are written by tens of thousands of writers.   （文件695.77MB）',
    list: [
      {
        label: '数据规模',
        text: '99109张图片'
      },
      {
        label: '数据类型',
        text: '手写数学公式'
      },
      {
        label: '数据格式',
        text: '图片：.jpg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://static-growth-fe.saasp.vdyoo.com/growthFeProject/growthFeSource/growthImagesLibrary/TAL_OCR_FORMULA.png',
    fileStyle: {
      width: '285px',
      height: '100px'
    },
    result: '\\frac { 2 x - 6 } { 2 } = 6'
  },
  {
    title: 'TAL_OCR_TABLE表格识别竞赛训练集',
    download: 'TAL_OCR_TABLE',
    description:
      '表格识别数据集为真实教育场景下学生拍照搜题的各类表格数据，总计1.6w张图片，每张图片提供了对应的表格结构和内容标注。该数据集为“2021好未来表格识别大赛”指定训练集。（文件1.11GB）',
    list: [
      {
        label: '数据规模',
        text: '1.6万张图片'
      },
      {
        label: '数据类型',
        text: '教育场景表格图片'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.json'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_TABLE.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5224357982&Signature=lAC15iDy3V01NP2TlYT9SNVv%2BXQ%3D',
    fileStyle: {
      width: '414px',
      height: '94px'
    },
    result:
      '1:测定次数,2:第1次,3:第2次,4:第3次,5:第4次,\n6:pH,7:4.92,8:4.82,9:4.76,10:4.75'
  }
];
const audioList = [
  {
    title: '成人中文授课音频',
    download: 'TAL_ASR',
    description:
      '语音识别数据集为好未来线上课程的老师授课音频，涵盖语文、数学两门学科。共包含80+说话人，每条音频只有一位说话人。标注数据包含了科目及说话人编号。训练集、验证集、测试集比例为7：1：2（3个文件共9.03G）',
    list: [
      {
        label: '数据规模',
        text: '100小时'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '80+'
      },
      {
        label: '录制时间',
        text: '2018年4月 ~ 5月'
      },
      {
        label: '数据格式',
        text: '语音：.wav单声道；标注结果：.txt'
      },
      {
        label: '音频长度',
        text: '1 ~ 60s'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_ASR.wav?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123459&Signature=l%2FLT3GOaWnAMm6OXNlzO4%2FvwEFE%3D',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result:
      '这两个数他们也叫好朋友数为什么呢它们的个位能够凑成整十只要是个位能凑整十都叫好朋友数'
  },
  {
    title: '成人中文语音情感分类',
    download: 'TAL_SER',
    description:
      '语音情感数据集为好未来老师上课音频，共包含4541条音频，总时长12.5小时。录音在安静的室内环境中录制，每条音频只有一个说话人。标注包括愉悦度（Pleasure）和激情度（Arousal）两个维度，每个音频片段对应一个P值和A值，范围都在[-3,3]之间，值越大表示愉悦度或激情度越高。（文件1.16GB）',
    list: [
      {
        label: '数据规模',
        text: '12.5小时'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '42人，男性：18人，女性：24人'
      },
      {
        label: '数据格式',
        text: '语音：.wav单声道；标注结果：.txt'
      },
      {
        label: '音频长度',
        text: '10s'
      },
      {
        label: '准确率',
        text: '96%'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_SER.wav?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123479&Signature=eENd%2FzYpThut5mDjn0GtF%2BBLs6A%3D',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result:
      'ID: 900    P: -0.046    A: 0.93     speaker: SER005     gender: man'
  },
  {
    title: '成人中英文混合授课音频',
    download: 'TAL_CSASR',
    description:
      '该数据集为好未来英语课授课音频，包含中英文混合讲话的情况，每条音频只有一位说话人。（文件63.36G）',
    list: [
      {
        label: '数据规模',
        text: '587小时音频'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '200+'
      },
      {
        label: '录制时间',
        text: '2019年'
      },
      {
        label: '数据格式',
        text: '音频：.wav；标注结果：.txt'
      },
      {
        label: '音频长度',
        text: '1～60s'
      },
      {
        label: '数据类型',
        text: '英语课教师授课音频'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_CSASR.wav?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5212515369&Signature=Y0GrI2UvVuAw4k6fQpIcg8uPARY%3D',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result:
      'HE MUST BE HOME NOW FOR THE LIGHT IS ON 他一定在家，因为灯亮着。就是有一种推理或者解释的那种感觉。'
  },
  {
    title: '儿童中文朗读',
    download: 'TAL_Children_CN_Read',
    description:
      '数据集为好未来线上课程的爆款儿童声音音频，涵盖语文、数学等学科。共包含30+说话人。（文件489.3MB）',
    list: [
      {
        label: '数据规模',
        text: '5.4小时音频'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '30+'
      },
      {
        label: '录制时间',
        text: '2020-2021年'
      },
      {
        label: '数据格式',
        text: '音频：.wav'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_children_cn_read.wav',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result: ''
  },
  {
    title: '儿童英文朗读',
    download: 'TAL_Children_EN_Read',
    description:
      '数据集为好未来线上课程的儿童声音英语音频，共包含30+说话人。（文件424.7MB）',
    list: [
      {
        label: '数据规模',
        text: '4.5小时音频'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '30+'
      },
      {
        label: '数据格式',
        text: '音频：.wav'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_children_en_read.wav',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result: ''
  },
  {
    title: '成人中文朗读',
    download: 'TAL_Adult_CN',
    description:
      '数据集为好未来线上课程老师的声音音频，涵盖语文、数学等学科。共包含100+说话人。（文件146.6G）',
    list: [
      {
        label: '数据规模',
        text: '1750小时音频'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '100+'
      },
      {
        label: '录制时间',
        text: '2020-2021年'
      },
      {
        label: '数据格式',
        text: '音频：.wav'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_audit_cn_read.wav',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result: ''
  },
  {
    title: '成人英文朗读',
    download: 'TAL_Adult_EN_Read',
    description:
      '数据集为好未来线上英文课程的老师声音音频，共包含100+说话人。（文件12.68G）',
    list: [
      {
        label: '数据规模',
        text: '180小时音频'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '100+'
      },
      {
        label: '录制时间',
        text: '2020-2021年'
      },
      {
        label: '数据格式',
        text: '音频：.wav'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_audit_en_read.wav',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result: ''
  },
  {
    title: '成人英文授课音频',
    download: 'TAL_EN_Adult',
    description:
      '数据集为好未来线上英文课程的老师授课音频，共包含100+说话人。（文件12.06G）',
    list: [
      {
        label: '数据规模',
        text: '160小时音频'
      },
      {
        label: '采样率',
        text: '16KHz'
      },
      {
        label: '采样位声',
        text: '16bit'
      },
      {
        label: '录制设备',
        text: '普通麦克风'
      },
      {
        label: '说话人',
        text: '100+'
      },
      {
        label: '录制时间',
        text: '2020-2021年'
      },
      {
        label: '数据格式',
        text: '音频：.wav'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_audit_en_teach.wav',
    fileStyle: {
      width: '518px',
      height: '40px'
    },
    result: ''
  }
];
const ocrList = [
  {
    title: '小学算数式子(手写+印刷)',
    download: 'TAL_OCR_MATH',
    description:
      '算数数据集为小学数学1到3年级的学生手写数学式子，共3万图片。每个数学式子经过手工裁剪。每个图像提供了对应标注。特殊数学符号标注方式请查看字符对应表。（文件87.04MB）',
    list: [
      {
        label: '数据规模',
        text: '3万张图片'
      },
      {
        label: '数据类型',
        text: '小学1~3年级学生习题册'
      },
      {
        label: '公式类型',
        text: '横式'
      },
      {
        label: '运算',
        text: '加、减、乘、除'
      },
      {
        label: '数据格式',
        text: '图片：.jpg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_MATH.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123384&Signature=tJnKYwJBNL0vxJT3KpzUBH8M8Ug%3D',
    fileStyle: {
      width: '243px',
      height: '80px'
    },
    result: '340b14=Z4Z7Z6Z0（b：代表×，Z：手写标志）'
  },
  {
    title: '手写中文(手写)',
    download: 'TAL_OCR_CHN',
    description:
      '手写中文数据集为30名大学生手写的中文古诗词，总计11739张图片，每张图片提供了对应的文本内容标注。（文件183.92MB）',
    list: [
      {
        label: '数据规模',
        text: '11739张图片'
      },
      {
        label: '数据类型',
        text: '手写中文古诗词'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_CHN.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123413&Signature=q2pSnzNG0xdTpBw5z5GBrDi8tY4%3D',
    fileStyle: {
      width: '592px',
      height: '58px'
    },
    result: '加。柳下桃蹊，乱分春色到人家。'
  },
  {
    title: '手写英文(手写)',
    download: 'TAL_OCR_ENG',
    description:
      '手写英文数据集为学生手写英文作文，总计1万行英文，对应1万张图片，每张图片提供了对应的文本内容标注。（文件222.16MB）',
    list: [
      {
        label: '数据规模',
        text: '1万张图片'
      },
      {
        label: '数据类型',
        text: '手写英文'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_ENG.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123438&Signature=HlCFi8izUji0pLvZPdwhtWzcwDI%3D',
    fileStyle: {
      width: '644px',
      height: '55px'
    },
    result: 'Because eating fast food is a simple way to eat.'
  },
  {
    title: 'K-12 教辅书题目(印刷体)',
    download: 'TAL_OCR_ASSISTANT',
    description:
      '截取的教辅中试题图片，共计47845张。学科涉及数学、语文等多个学科。每张图片都有对应标注，标注内容包括每一行文本的坐标及对应文字内容。(文件2.25GB)',
    list: [
      {
        label: '数据规模',
        text: '47485'
      },
      {
        label: '数据类型',
        text: '教辅试题图片'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_ASSISTANT.png',
    fileStyle: {
      width: '306px',
      height: '108px'
    },
    // eslint-disable-next-line no-tabs
    result:
      'label包含文本框坐标及对应文本行的内容，格式如下，\n x0 y0 x1 y1 文本内容，其中x0，y0代表文本框左上角坐标，x1，y1代表坐标框右下角坐标。 \n \n 示例图详细label如下，\n 2 37 408 8 五、写出下列各组数的最小公倍数。\n 43 48 881 89 1.9和18 16和48 7和35 12和36 \n 82 95 872 135 ( ) ( ) ( ) ( ) \n 45 144 976 197 如果两个数是倍数关系，它们的最小公倍数是___。\n 33 205 885 241 2.6和7 3和11 5和9 8和11 \n 76 252 861 292 ( ) ( ) ( ) ( ) \n 34 290 976 338 如果两个数是互质关系，它们的最小公倍数是___。'
  },
  {
    title: '点阵笔输入小学数学手写',
    download: 'TAL_OCR_LOCUS',
    description:
      '轨迹数据集为通过手写轨迹生成的图片，共计41910张图片。图片内容包括文字、公式等，每张图片提供对应标注。（文件561.7MB）',
    list: [
      {
        label: '数据规模',
        text: '41912'
      },
      {
        label: '数据类型',
        text: '手写轨迹生成图片'
      },
      {
        label: '数据格式',
        text: '图片：.jpeg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_LOCUS.png',
    fileStyle: {
      width: '159px',
      height: '61px'
    },
    result: 'x + y < 1 0'
  }
];
const NLPList = [
  {
    title: '文本情感分类',
    download: 'TAL_NLP_TXT',
    description:
      '文本情感分类数据集是在客服场景下的情绪分类数据，总计1634条数据，包含负面情绪、中性情绪各700条，正面情绪234条；每条数据包含文本信息及label标签， 对个人姓名进行匿名处理(xxx)，剔除手机号、地址等个人信息。（文件44KB）',
    list: [
      {
        label: '数据规模',
        text: '1634条'
      },
      {
        label: '数据类型',
        text: '文本情感'
      },
      {
        label: '数据格式',
        text: 'jsonl; {id:"",label:"";text:""} '
      },
      {
        label: '情感类型',
        text: '0:负面情绪  1:中性情绪  2:正面情绪'
      }
    ],
    fileSrc: '',
    fileStyle: {
      width: '0',
      height: '0'
    },
    result: `{'id': '5231496807', 'label': '1', 'text': '我是武汉的报的是寒假班2期有两节课没上完就停课后来app上显示今天上课问题是今天没有上课但费用显示已扣我想问下这个怎么处理'}
    {'id': '6718495302', 'label': '0', 'text': '每次上课都着急死'}
    label：0:负面情绪  1:中性情绪  2:正面情绪 ;text:文本信息;id为随机生成数`
  },
  {
    title: '题目自动标签',
    download: 'TAL_NLP_TM',
    description:
      '题目自动标签数据集总计1600条题目数据，包含答案，学科，题目类型，年级，难度，知识点六类标签。其中每个学科各有共200条数据。语文，数学，英语的题目数据分为小学（60条），初中（70条），高中（70条）。其中小学的题目数据中不同难度（易、中档、难）的各有20条；初中和高中的题目数据中难度为易的有20条，难度为中档的有30条，难度为难的有20条。物理，化学，生物，历史，政治的题目数据分为初中（100条），高中（100条）。其中初中的题目数据中难度为易、中档各有40条，高中的题目数据中难度为易的有50条，难度为中档的有60条，难度为难的有10条。（文件335KB）',
    list: [
      {
        label: '数据规模',
        text: '1600条'
      },
      {
        label: '数据类型',
        text: '题目自动标签'
      },
      {
        label: '数据格式',
        text: 'jsonl; {题目:"", 答案:"", 学科:"", 题目类型:"", 年级:"", 难度:"", 知识点:""} '
      },
      {
        label: '学科',
        text: '数学，语文，英语，物理，化学，生物，历史，政治'
      },
      {
        label: '题目类型',
        text: '单选，解答，多选，填空，判断，配对，完形填空'
      },
      {
        label: '年级',
        text: '小学，初中，高中'
      },
      {
        label: '难度',
        text: '易，中档，难'
      },
      {
        label: '知识点',
        text: '例：化学方程式的书写，氧气的制取实验'
      }
    ],
    fileSrc: '',
    fileStyle: {
      width: '0',
      height: '0'
    },
    result:
      '{"题目": "在托盘天平两边各放一只等质量的烧杯，在两只烧杯里分别加入$$50{g}$$溶质质量分数为$$7.3\\%$$的稀盐酸，将天平调节至平衡；然后向左右两烧杯中分别加入一定质量的下列各组物质，充分反应后，天平发生偏转的是(  )\nA. $$1.8{g}$$铝粉和$$1.8{g}$$铁粉\nB. $$4.2{g}$$碳酸镁和$$2{g}$$硝酸银\nC. $$5.6{g}$$铁粉和$$5.6{g}$$锌粉\nD. $$7.8{g}$$碳酸钙和$$5.6{g}$$氧化钙\n", "答案": "A.$$1.8{g}$$铝粉和$$1.8{g}$$铁粉", "学科": "化学", "题目类型": "单选", "年级": "初中", "难度": "中档", "知识点": "化学反应中，利用质量守恒定律的计算;根据质量守恒的计算;变化观念与平衡思想;守恒思想;定性与定量思想;金属与酸及盐溶液反应的天平、杠杆变化问题"}'
  },
  {
    title: '中文修辞手法分类',
    download: 'TAL_NLP_CHN',
    description:
      '中文修辞手法分类数据集总计4609条数据，包含排比、拟人、比喻、设问、反问五个类型修辞手法且每个类型包含正反样例各500条。（文件324KB）',
    list: [
      {
        label: '数据规模',
        text: '4609条'
      },
      {
        label: '数据类型',
        text: '中文修辞手法'
      },
      {
        label: '数据格式',
        text: 'jsonl; {text："", label：""}'
      },
      {
        label: '修辞类型',
        text: '"排比", "拟人", "比喻", "设问", "反问"'
      }
    ],
    fileSrc: '',
    fileStyle: {
      width: '0',
      height: '0'
    },
    result:
      '{text："\'家是我们心灵的避难所；家，是我们休息的港湾；家，是我们生活下去的动力！",label：[1, -1, 1, -1, -1]}label标签依次是：["排比", "拟人", "比喻", "设问", "反问"]  0：否 1:是 -1:无效'
  },
  {
    title: '中文k12领域大模型评测集',
    download: '',
    description:
      '我们利用了k12教育领域知识图谱构建了一个大模型的评测集。 总计41328道题目，包括500+一级知识点和1900+二级知识点，覆盖了K12教育领域的所有知识点。具有五个不同类型的题型， 对于单选和多选我们打乱了选项，并添加了干扰项。 提出该数据集的主要目的是全面评估LLM在中文语境下的高级理解能力和推理能力。',
    list: [
      {
        label: '数据规模',
        text: '41328个'
      },
      {
        label: '数据类型',
        text: '问答题'
      },
      {
        label: '数据格式',
        text: 'jsonl; {"id":"", "prompt": "", "answer_option":"", "answer": "", "analysis": "","task_type": "", "task_subject": "","task_grade": "","task_semester": "","difficulty": "","knowledge_tree": "","knowledge_domain":",}'
      }
    ],
    fileSrc: '',
    fileStyle: {
      width: '0',
      height: '0'
    },
    // eslint-disable-next-line no-template-curly-in-string
    result:
      '{"id": "1f82100ac6624bd5ad66fdc805f1954f", "prompt": "某企业$$2018$$年初获利润$$300$$万元，到$$2020$$年初计划利润达到$$507$$万元．设这两年的年利润平均增长率为$$x$$，应列方程是（   ）．\n", "answer_option": ["A.$$300(1+x)=507$$", "B.$$300{{(1+x)}^{2}}=507$$", "C.$$300(1+x)+300{{(1+x)}^{2}}=507$$", "D.$$300+300(1+x)+300{{(1+x)}^{2}}=507$$"], "answer": "B", "analysis": "设这两年的年利润平均增长率为$$x$$，\n根据题意得：$$300{{(1+x)}^{2}}=507$$．\n故选：$${B}$$．\n", "task_type": "单选", "task_subject": "数学", "task_grade": "初中", "task_semester": "上学期", "difficulty": "较易", "knowledge_tree": "方程与不等式-一元二次方程-一元二次方程与实际问题-一元二次方程的增长率问题", "knowledge_domain": ["初中", "数学", "知识点", "方程与不等式", "方程与不等式"]}'
  }
];
const pictureList = [
  {
    title: '手势识别开源数据',
    download: 'TAL_IMAGE',
    description:
      "手势识别数据集包括常见的19种手势类别，共9万5千张手势图片，每张图片具体类别见子目录名字。具体的手势类别：['rock', 'prayer', 'other', 'heart_1', 'point', 'heart_3', 'thumb_down', 'three', 'fist', 'two', 'palm_up', 'palm', 'honour', 'heart_2', 'thumb_up', 'ok', 'heart_single', 'four', 'congratulation']。（文件1.5GB）",
    list: [
      {
        label: '数据规模',
        text: '95313张'
      },
      {
        label: '数据类型',
        text: '常见19种手势类别'
      },
      {
        label: '数据格式',
        text: '图片: .jpg, .jpeg'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_IMAGE.png',
    fileStyle: {
      width: '120px',
      height: '120px'
    },
    result: 'palm'
  }
];
const formulaRecognitionList = [
  {
    title: 'K-12 手写体（HME100K）',
    download: 'TAL_OCR_FORMULA',
    description:
      'The HME100K dataset provides 99,109 images (74,502 for training and 24,607 for testing) with 245 kinds of symbol classes. The data size is increased tenfold compared to the CRHOME datasets. HME100K acquires the expressions from an Internet application. Therefore, we may assume that the expressions are written by tens of thousands of writers.   （文件728.8MB）',
    list: [
      {
        label: '数据规模',
        text: '99109张图片'
      },
      {
        label: '数据类型',
        text: '手写数学公式'
      },
      {
        label: '数据格式',
        text: '图片：.jpg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://static-growth-fe.saasp.vdyoo.com/growthFeProject/growthFeSource/growthImagesLibrary/TAL_OCR_FORMULA.png',
    fileStyle: {
      width: '285px',
      height: '100px'
    },
    result: '\\frac { 2 x - 6 } { 2 } = 6'
  },
  {
    title: 'K-12 印刷体',
    download: 'TAL_OCR_PRINT_FORMULA',
    description:
      '手工裁剪的印刷文本图片，数据来源为教辅试题，共计256646张图片。学科涉及数学、语文等多学科。每张图片都有对应标注。（文件1.9GB）',
    list: [
      {
        label: '数据规模',
        text: '256646'
      },
      {
        label: '数据类型',
        text: '印刷图片'
      },
      {
        label: '数据格式',
        text: '图片：.jpg；标注结果：.txt'
      }
    ],
    fileSrc:
      'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/sample_TAL_OCR_FORMULA_PRINT.png',
    fileStyle: {
      width: '612px',
      height: '18px'
    },
    result:
      '了一倍；先前的紫色的圆脸，已经变作灰黄，而且加上了很深的皱纹；眼睛也像他父亲一样，周围'
  }
];
const knowledgeGraphList = [
  {
    title: '小学数学知识点标签体系',
    download: 'TAL_OCR_FORMULA',
    description:
      '一个基于知识图谱技术构建的数学知识点索引系统，旨在帮助小学教师和学生更好地了解和学习数学知识。该知识点标签体系将小学数学知识点分为数学基本概念、数和代数、空间和几何、数据和概率四大类，每个类别下又分别包含多个具体的子类别，如数的大小、数的应用、数的比较等。通过这样的分类和标签体系，学生和教师可以快速查找、定位和了解各种数学知识点，更好地理解数学的概念和原理，提高数学的学习效率和质量。同时，基于知识图谱技术，该体系将数学知识点之间的关系进行了建模和表示，可以更好地帮助学生和教师掌握数学的整体框架和结构，快速地准确地把握各种数学知识点之间的联系和关联，提高数学的整体性和深度。（文件1.2MB）'
  }
];
const dataset = {
  banner:
    'https://openplantform.oss-cn-beijing.aliyuncs.com/dataset/banner.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4743123009&Signature=QfpnGAhblCPF4ae%2BrnMT0Bg4ZE0%3D',
  // image: imageList,
  // audio: audioList,
  ocrList,
  NLPList,
  pictureList,
  formulaRecognitionList,
  audioList,
  knowledgeGraphList
};
export default dataset;
